"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutatePositionAssignDelete = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const positionAssignDeleteMutation = (0, graphql_tag_1.default) `
  mutation PositionAssignDelete($workspaceId: ID!, $positionId: ID!, $userId: ID!, $contractId: ID!) {
    positionAssignDelete(workspace: $workspaceId, position: $positionId, user: $userId, contract: $contractId)
  }
`;
const mutatePositionAssignDelete = async (variables) => {
    const { errors } = await (0, apollo_1.mutate)(positionAssignDeleteMutation, {
        variables,
    });
    (0, error_handler_1.processErrors)(errors);
};
exports.mutatePositionAssignDelete = mutatePositionAssignDelete;
